module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC45bDN+TgAAAJRJREFUOE+1lLsNwCAMBb0AFQ1tVsgKlNl/Hsd8ImF4oIg4lq7gxLNAJiFmNgXKL0DZIuUEX3FoTwuUCakgROHqSC6gTAJLoqOGV5wwO4hyMtQAMZxULbLA15wRh7xalAGg4Ao1qL5hmiQKrfCqh1r80ND2yllYDiUL62eTpTzaJjTj3cN+kLL79FqkbH4Ou0C5D9MN1WOfAhie+GEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_black_old.png
// module id = P7Sc
// module chunks = 1